import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import {
  Home as HomeIcon,
  Chat as ChatIcon,
  Public as PublicIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

export const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getPathValue = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path.startsWith('/chat')) return 'chat';
    if (path.startsWith('/continents') || path.startsWith('/countries') || path.startsWith('/markets'))
      return 'browse';
    if (path.startsWith('/search')) return 'search';
    if (path.startsWith('/settings')) return 'settings';
    return 'home';
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderTop: 1,
        borderColor: 'divider',
        // Only hide on mobile landscape (not desktop)
        '@media (max-width: 768px) and (orientation: landscape)': {
          display: 'none',
        },
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getPathValue()}
        onChange={(_event, newValue) => {
          switch (newValue) {
            case 'home':
              navigate('/');
              break;
            case 'chat':
              navigate('/chat');
              break;
            case 'browse':
              navigate('/continents');
              break;
            case 'search':
              navigate('/search');
              break;
            case 'settings':
              navigate('/settings');
              break;
          }
        }}
        showLabels
        sx={{
          height: '80px',
          alignItems: 'flex-start',
          '& .Mui-selected': {
            color: '#F5A800',
          },
          '& .MuiBottomNavigationAction-root': {
            paddingTop: '8px',
            minHeight: 'auto',
          },
          '& .MuiBottomNavigationAction-root.Mui-selected': {
            color: '#F5A800',
          },
        }}
      >
        <BottomNavigationAction label="Home" value="home" icon={<HomeIcon />} />
        <BottomNavigationAction label="Search" value="search" icon={<SearchIcon />} />
        <BottomNavigationAction label="Browse" value="browse" icon={<PublicIcon />} />
        <BottomNavigationAction label="Chat" value="chat" icon={<ChatIcon />} />
        <BottomNavigationAction label="Settings" value="settings" icon={<SettingsIcon />} />
      </BottomNavigation>
    </Paper>
  );
};
